// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-dashboard {
    padding: 40px;
    background-color: white;
}

.section {
    margin-bottom: 50px;
}

.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.section-title {
    font-size: 20px;
    font-weight: bold;
    margin: 0;
    border-left: 5px solid #e84118;
    padding-left: 10px;
}

.stats-container {
    display: grid;
    grid-template-columns: 1fr 1fr 1.5fr;
    gap: 30px;
    margin-bottom: 20px;
}

.stat-card {
    background-color: white;
    border: 1px solid #eee;
    border-radius: 5px;
    padding: 20px;
}

.stat-card h3 {
    margin: 0 0 20px 0;
    font-size: 16px;
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;
    font-weight: normal;
}

.stat-body {
    display: flex;
    justify-content: space-around;
    text-align: center;
}

.stat-body p {
    margin: 0;
    font-size: 14px;
    color: #666;
}

.stat-body .count {
    font-size: 28px;
    font-weight: bold;
    margin-top: 10px;
    color: #222;
}

.chart-card {
    padding-bottom: 0;
}

.chart {
    position: relative;
    height: 120px;
    display: flex;
}

.chart-y-axis {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 90px;
    font-size: 12px;
    color: #999;
    padding-right: 10px;
    text-align: right;
}

.chart-svg {
    width: 100%;
    height: 90px;
    overflow: visible;
}

.chart-x-axis {
    position: absolute;
    bottom: 0;
    left: 40px;
    right: 0;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #999;
}

.dashboard-button {
    background-color: #222;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
}

.recent-signups-container {
    background-color: white;
    border: 1px solid #eee;
    border-radius: 5px;
    padding: 20px;
}

.recent-signups-table {
    width: 100%;
    border-collapse: collapse;
}

.recent-signups-table th, .recent-signups-table td {
    padding: 15px;
    text-align: center;
    border-bottom: 1px solid #eee;
    font-size: 14px;
}

.recent-signups-table th {
    font-weight: bold;
    background-color: #fcfcfc;
}

.table-footer {
    text-align: center;
    padding-top: 15px;
    font-size: 20px;
    letter-spacing: 5px;
    color: #999;
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .stats-container {
        grid-template-columns: 1fr 1fr;
    }

    .admin-dashboard {
        padding: 20px;
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .stats-container {
        grid-template-columns: 1fr;
    }

    .stat-body {
        flex-direction: column;
        gap: 15px;
    }
    
    .recent-signups-table thead {
        display: none;
    }
    
    .recent-signups-table, .recent-signups-table tbody, .recent-signups-table tr, .recent-signups-table td {
        display: block;
        width: 100%;
    }
    
    .recent-signups-table tr {
        margin-bottom: 15px;
        border: 1px solid #ddd;
        border-radius: 5px;
        overflow: hidden;
    }

    .recent-signups-table td {
        text-align: right;
        padding-left: 50%;
        position: relative;
    }

    .recent-signups-table td::before {
        content: attr(data-label);
        position: absolute;
        left: 15px;
        width: calc(50% - 30px);
        padding-right: 10px;
        white-space: nowrap;
        text-align: left;
        font-weight: bold;
    }
} `, "",{"version":3,"sources":["webpack://./src/admin/css/AdminDashboardPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,SAAS;IACT,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,YAAY;IACZ,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,QAAQ;IACR,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,WAAW;AACf;;AAEA,+BAA+B;AAC/B;IACI;QACI,8BAA8B;IAClC;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,mBAAmB;QACnB,sBAAsB;QACtB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,kBAAkB;QAClB,UAAU;QACV,uBAAuB;QACvB,mBAAmB;QACnB,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;IACrB;AACJ","sourcesContent":[".admin-dashboard {\n    padding: 40px;\n    background-color: white;\n}\n\n.section {\n    margin-bottom: 50px;\n}\n\n.section-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.section-title {\n    font-size: 20px;\n    font-weight: bold;\n    margin: 0;\n    border-left: 5px solid #e84118;\n    padding-left: 10px;\n}\n\n.stats-container {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1.5fr;\n    gap: 30px;\n    margin-bottom: 20px;\n}\n\n.stat-card {\n    background-color: white;\n    border: 1px solid #eee;\n    border-radius: 5px;\n    padding: 20px;\n}\n\n.stat-card h3 {\n    margin: 0 0 20px 0;\n    font-size: 16px;\n    border-bottom: 1px solid #eee;\n    padding-bottom: 20px;\n    font-weight: normal;\n}\n\n.stat-body {\n    display: flex;\n    justify-content: space-around;\n    text-align: center;\n}\n\n.stat-body p {\n    margin: 0;\n    font-size: 14px;\n    color: #666;\n}\n\n.stat-body .count {\n    font-size: 28px;\n    font-weight: bold;\n    margin-top: 10px;\n    color: #222;\n}\n\n.chart-card {\n    padding-bottom: 0;\n}\n\n.chart {\n    position: relative;\n    height: 120px;\n    display: flex;\n}\n\n.chart-y-axis {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    height: 90px;\n    font-size: 12px;\n    color: #999;\n    padding-right: 10px;\n    text-align: right;\n}\n\n.chart-svg {\n    width: 100%;\n    height: 90px;\n    overflow: visible;\n}\n\n.chart-x-axis {\n    position: absolute;\n    bottom: 0;\n    left: 40px;\n    right: 0;\n    display: flex;\n    justify-content: space-between;\n    font-size: 12px;\n    color: #999;\n}\n\n.dashboard-button {\n    background-color: #222;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.recent-signups-container {\n    background-color: white;\n    border: 1px solid #eee;\n    border-radius: 5px;\n    padding: 20px;\n}\n\n.recent-signups-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.recent-signups-table th, .recent-signups-table td {\n    padding: 15px;\n    text-align: center;\n    border-bottom: 1px solid #eee;\n    font-size: 14px;\n}\n\n.recent-signups-table th {\n    font-weight: bold;\n    background-color: #fcfcfc;\n}\n\n.table-footer {\n    text-align: center;\n    padding-top: 15px;\n    font-size: 20px;\n    letter-spacing: 5px;\n    color: #999;\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .stats-container {\n        grid-template-columns: 1fr 1fr;\n    }\n\n    .admin-dashboard {\n        padding: 20px;\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .stats-container {\n        grid-template-columns: 1fr;\n    }\n\n    .stat-body {\n        flex-direction: column;\n        gap: 15px;\n    }\n    \n    .recent-signups-table thead {\n        display: none;\n    }\n    \n    .recent-signups-table, .recent-signups-table tbody, .recent-signups-table tr, .recent-signups-table td {\n        display: block;\n        width: 100%;\n    }\n    \n    .recent-signups-table tr {\n        margin-bottom: 15px;\n        border: 1px solid #ddd;\n        border-radius: 5px;\n        overflow: hidden;\n    }\n\n    .recent-signups-table td {\n        text-align: right;\n        padding-left: 50%;\n        position: relative;\n    }\n\n    .recent-signups-table td::before {\n        content: attr(data-label);\n        position: absolute;\n        left: 15px;\n        width: calc(50% - 30px);\n        padding-right: 10px;\n        white-space: nowrap;\n        text-align: left;\n        font-weight: bold;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
